import { Dialog, DialogActions } from '@material-ui/core';
import { useMultiPageWizard } from './use-multi-page-wizard';
import { Button } from '@catapultsports/referee-react';
import { IconCancelSmall } from '@catapultsports/referee-react/icons';
import { useTranslations } from 'i18n';

interface MultiPageModalProps {
    isOpen: boolean;
    handleClose: (isOpen: boolean) => void;
}

export const MultiPageModal: React.FunctionComponent<MultiPageModalProps> = (props) => {
    const { isOpen, handleClose } = props;
    const { __ } = useTranslations();
    const { steps, currentStepIndex, next, back, isFirstStep, isLastStep } = useMultiPageWizard();

    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={isOpen}
            onClose={(_, reason) => {
                if (reason === 'backdropClick') {
                    return;
                }
                handleClose(false);
            }}
        >
            <DialogActions>
                <Button onClick={() => handleClose(false)} title="cancel" variant="text">
                    <IconCancelSmall />
                </Button>
            </DialogActions>
            {steps[currentStepIndex]}
            <DialogActions>
                <Button
                    onClick={() => {
                        if (isFirstStep) {
                            handleClose(false);
                        } else {
                            back();
                        }
                    }}
                    variant="text"
                >
                    {isFirstStep ? __('misc.confirm_no') : __('misc.back')}
                </Button>
                <Button
                    disabled={steps.length === 1}
                    onClick={() => {
                        if (isLastStep) {
                            handleClose(false);
                        } else {
                            next();
                        }
                    }}
                >
                    {isFirstStep ? __('misc.get_started') : isLastStep ? __('smt_importer.import') : __('misc.next')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
